var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var SectionTitle = styled.h4(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  color: ", ";\n  font-size: 2rem;\n  font-weight: 500;\n  letter-spacing: 0.17px;\n  line-height: 1.2em;\n  margin: 0 0 15px 0;\n"], ["\n  display: inline-block;\n  color: ", ";\n  font-size: 2rem;\n  font-weight: 500;\n  letter-spacing: 0.17px;\n  line-height: 1.2em;\n  margin: 0 0 15px 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.generalContent.text.alt.color;
});
var templateObject_1;
//# sourceMappingURL=SectionTitle.js.map